export default {
  isLoading: true,
  companyList: [],
};
